import { useEffect, useState } from 'react';

// Cross-subdomain user snapshot set by the portal on login. See
// adminpanel/src/utils/auth.js.
const FLAG_COOKIE = 'mdai_authed';
const NAME_COOKIE = 'mdai_name';
const ROLE_COOKIE = 'mdai_role';

function readCookie(name) {
  if (typeof document === 'undefined') return '';
  for (const raw of document.cookie.split(';')) {
    const part = raw.trim();
    const eq = part.indexOf('=');
    if (eq === -1) continue;
    if (part.slice(0, eq) === name) {
      try { return decodeURIComponent(part.slice(eq + 1)); } catch { return ''; }
    }
  }
  return '';
}

function snapshot() {
  if (readCookie(FLAG_COOKIE) !== '1') return null;
  return {
    firstName: readCookie(NAME_COOKIE) || '',
    role: readCookie(ROLE_COOKIE) || '',
  };
}

// Returns `null` when signed out, `{ firstName, role }` when signed in.
// Re-reads cookies on tab focus / visibility change so a user who just
// signed in on the portal sees the landing page update on return.
export function useAuthUser() {
  const [user, setUser] = useState(snapshot);

  useEffect(() => {
    const check = () => setUser(snapshot());
    window.addEventListener('focus', check);
    document.addEventListener('visibilitychange', check);
    return () => {
      window.removeEventListener('focus', check);
      document.removeEventListener('visibilitychange', check);
    };
  }, []);

  return user;
}
